import { useSession } from 'next-auth/react';

export const useSessionSafe = () => {
  const session = useSession() ?? {};
  return session;
};
